import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { CotizacionModel } from '../models/cotizacion.model';
import { ProyectoModel } from '../models/proyecto.model';

import { ResponseBaseModel, ResponseModel } from '../models/response.model';

import { Dependencia } from '../models/dependencia.model';
import { Global } from './global';
import { TipoDeObra } from '../models/tipo-de-obra.model';
import { map } from 'rxjs/operators';
import { TipoDeEstatus } from '../models/tipo-de-estatus.model';
import { IncidenciaCotizacion, IncidenciaCotizacionRequest, IncidenciaCotizacionUpdateRequest } from '../models/incidencia.model';
import { FactorDeCalidad } from '../models/factorcalidad.model';
import { Productos } from '../models/producto.model';
import { RegistroRequest } from '../models/registro.model';
import { Comprobante, Recibo } from '../models/comprobante.model';

@Injectable({
  providedIn: 'root',
})
export class ProyectoService {
  public apiUrl;
  public $arquitecto = new EventEmitter();

  constructor(private _http: HttpClient) {
    this.apiUrl = Global.baseUrl;
  }

  getSalarioMinimoVigente(): Observable<ResponseModel<any>> {
    return this._http
      .post<ResponseModel<any>>(
        `${this.apiUrl}/Proyecto/Cotizacion/SalarioMinimoVigente`,
        {}
      );
  }

  // Obtiene todos los proyectos
  getAllProyectos(): Observable<any> {
    return this._http.get(`${this.apiUrl}/Proyecto`);
  }

  getProyecto(idProyecto: number): Observable<any> {
    return this._http.get(`${this.apiUrl}/Proyecto/${idProyecto}`);
  }

  getProyectosBySocio(idSocio: number): Observable<any> {
    return this._http.get(`${this.apiUrl}/Proyecto/Socio/${idSocio}`);
  }

  getProyectoFotos(idProyecto: number): Observable<any> {
    return this._http.get(`${this.apiUrl}/Proyecto/Photos/${idProyecto}`);
  }

  setArquitecto(nombre: string) {
    this.$arquitecto.emit(nombre);
  }

  getTipodeProyecto() {
    return this._http.get<ResponseModel<TipoDeObra[]>>(`${this.apiUrl}/Proyecto/Cotizacion/TipoDeObra`);
  }

  //Obtiene el catálogo de categorías de un proyecto
  getCategoriasProyecto(): Observable<any> {
    return this._http.get(this.apiUrl + '/Proyecto/CategoriasProyecto');
  }

  //Obtiene los proyectos de un Socio
  getProyectoSocio(idSocio): Observable<any> {
    return this._http.get(this.apiUrl + '/Proyecto/Socio/' + idSocio);
  }

  //Crea un nuevo registro 'Proyecto'
  createProyecto(proyecto: ProyectoModel): Observable<any> {
    return this._http.post(this.apiUrl + '/Proyecto', proyecto);
  }

  //Actualiza un registro 'Proyecto'
  updateProyecto(proyecto: ProyectoModel): Observable<any> {
    const body = {
      ...proyecto,
    };
    return this._http.put(this.apiUrl + '/Proyecto', body);
  }

  //Elimina un registro 'Proyecto'
  deleteProyecto(idProyecto): Observable<any> {
    const param = '?idProyecto=' + idProyecto;
    return this._http.delete(this.apiUrl + '/Proyecto' + param);
  }

  //Obtiene las fotos de un proyecto
  getPhotos(idProyecto): Observable<any> {
    return this._http.get(this.apiUrl + '/Proyecto/Photos/' + idProyecto);
  }

  //Carga las fotos a un proyecto
  async uploadPhotos(imagenes) {
    return await this._http
      .post(this.apiUrl + '/Proyecto/Photos/', imagenes)
      .toPromise();
  }

  //Elimina las fotos de un proyecto
  deletePhotos(idFotografia): Observable<any> {
    return this._http.delete(this.apiUrl + '/Proyecto/Photos/' + idFotografia);
  }

  //Obtiene la cotización de un socio en base al idCotizacion
  getCotizacion(idCotizacion): Observable<any> {
    return this._http.get(this.apiUrl + '/Proyecto/Cotizacion/' + idCotizacion);
  }

  // Obtiene las cotizaciones de un socio en base al idSocio
  getHistorialCotizacionesSocio(idSocio): Observable<any> {
    return this._http.get(
      `${this.apiUrl}/Proyecto/Cotizacion/Socio/${idSocio}`
    );
  }

  getFactorCalidad(idUsoDeObra): Observable<any> {
    return this._http.get(
      this.apiUrl + '/Proyecto/FactorCalidad/' + idUsoDeObra
    );
  }

  getCalculoAranceles(cotizacion: CotizacionModel): Observable<any> {
    return this._http.post(
      this.apiUrl + '/Proyecto/Cotizacion/CalcularAranceles',
      cotizacion
    );
  }

  //Guarda la cotización de un Socio
  createCotizacion(cotizacion: CotizacionModel): Observable<any> {
    return this._http.post(this.apiUrl + '/Proyecto/Cotizacion', cotizacion);
  }

  updateCotizacion(cotizacion: CotizacionModel): Observable<any> {
    const body = {
      ...cotizacion,
    };

    let headers = new HttpHeaders().set('Authorization', 'Bearer ' + localStorage.getItem('token'));
    return this._http.put(this.apiUrl + '/Proyecto/Cotizacion', body, { headers: headers });
  }

  // Actualizar estatus de una cotización
  updateStatusCotizacion(idCotizacion: number, idEstatus: number) {
    return this._http.put(`${this.apiUrl}/Proyecto/Cotizacion/UpdateStatus`, {
      idCotizacion: idCotizacion,
      idEstatus: idEstatus,
    });
  }

  deleteCotizacion(idCotizacion: number): Observable<any> {
    let headers = new HttpHeaders().set('Authorization', 'Bearer ' + localStorage.getItem('token'));
    return this._http.delete(this.apiUrl + '/Proyecto/Cotizacion/' + idCotizacion, { headers: headers });
  }

  getStatusCotizacion() {
    return this._http.get<ResponseModel<TipoDeEstatus[]>>(`${this.apiUrl}/Proyecto/EstatusCotizacion`);
  }

  getDependencias() {
    return this._http.get<ResponseModel<Dependencia[]>>(`${this.apiUrl}/Proyecto/Cotizacion/Dependencias`);
  }

  saveIncidencia(request: IncidenciaCotizacionRequest) {
    return this._http.post<ResponseModel<IncidenciaCotizacion>>(
      `${this.apiUrl}/Proyecto/Incidencia`,
      request,
    );
  }

  updateIncidencia(request: IncidenciaCotizacionUpdateRequest) {
    return this._http.put<ResponseModel<IncidenciaCotizacion>>(
      `${this.apiUrl}/Proyecto/Incidencia`,
      request,
    );
  }

  deleteIncidencia(idIncidencia: number) {
    return this._http.delete<ResponseBaseModel>(
      `${this.apiUrl}/Proyecto/Incidencia/${idIncidencia}`
    );
  }

  getIncidenciaById(idIncidencia: number) {
    return this._http.get<ResponseModel<IncidenciaCotizacion>>(
      `${this.apiUrl}/Proyecto/Incidencia/${idIncidencia}`
    );
  }

  getAllIncidenciasCotizacion(idCotizacion: number) {
    return this._http.get<ResponseModel<IncidenciaCotizacion[]>>(
      `${this.apiUrl}/Proyecto/Incidencia/${idCotizacion}/Cotizacion`
    );
  }

  getAllFactorCalidad(idFactor: number) {
    return this._http.get<ResponseModel<FactorDeCalidad[]>>(
      `${this.apiUrl}/Proyecto/FactorCalidad/${idFactor}`
    );
  }

  getAllProducts() {
    return this._http.get<ResponseModel<Productos[]>>(
      `${this.apiUrl}/Pagos/Productos/Todos`
    );
  }

  postRegistro(request: RegistroRequest) {
    return this._http.post<ResponseModel<RegistroRequest>>(
      `${this.apiUrl}/Registro`,
      request,
    );
  }

  getAllRegistro() {
    return this._http.get<ResponseModel<RegistroRequest[]>>(
      `${this.apiUrl}/Registro`
    );
  }

  postComprobante(request: Recibo) {
    return this._http.post<ResponseModel<Comprobante[]>>(
      `${this.apiUrl}/Pagos/Comprobante`,
      request
    );
  }

}
